export const NAMESPACE = 'supportStaff'
